<template>
  <Modal
    :title="$t('customize_itinerary_block')"
    :form="{ data: form, method: 'PUT', endpoint: `collections/${personalisationHashid}/blocks/${blockHashid}/customise` }"
    :confirm-label="$t('save')"
    @confirm="$modal.close"
  >
    <InputGroup
      :label="$t('title')"
      name="title"
    >
      <TextInput
        v-model="form.title"
        name="title"
      />
    </InputGroup>

    <InputGroup
      :label="$t('subtitle')"
      name="subtitle"
    >
      <TextInput
        v-model="form.subtitle"
        name="subtitle"
      />
    </InputGroup>

    <MarkdownInput
      v-model="form.synopsis"
      :label="$t('description')"
      name="synopsis"
      rows="12"
    />

    <InputGroup
      :label="$t('image')"
      name="featured_image"
    >
      <FileInput
        v-model="form.featured_image"
        name="featured_image"
      />
    </InputGroup>

    <h3>{{ $t("primary_cta") }}</h3>

    <InputGroup
      :label="$t('label')"
      name="primary_cta_label"
    >
      <TextInput
        v-model="form.primary_cta_label"
        name="primary_cta_label"
      />
    </InputGroup>

    <InputGroup
      :label="$t('link')"
      name="primary_cta_link"
    >
      <TextInput
        v-model="form.primary_cta_link"
        name="primary_cta_link"
      />
    </InputGroup>

    <h3>{{ $t("secondary_cta") }}</h3>

    <InputGroup
      :label="$t('label')"
      name="secondary_cta_label"
    >
      <TextInput
        v-model="form.secondary_cta_label"
        name="secondary_cta_label"
      />
    </InputGroup>

    <InputGroup
      :label="$t('link')"
      name="secondary_cta_link"
    >
      <TextInput
        v-model="form.secondary_cta_link"
        name="secondary_cta_link"
      />
    </InputGroup>

    <InputGroup name="hide_secondary_cta">
      <ToggleSwitch
        v-model="form.hide_secondary_cta"
        :label="$t('hide_secondary_cta')"
      />
    </InputGroup>
  </Modal>
</template>

<script setup lang="ts">
import type { ItineraryBlock } from '~/types/blocks'

const props = defineProps<{
  personalisationHashid: string
  blockHashid: string
}>()

const { data } = await useAsyncData(`customise-block-${props.personalisationHashid}-${props.blockHashid}`, () =>
  $larafetch<ItineraryBlock>(`collections/${props.personalisationHashid}/blocks/${props.blockHashid}`)
)

if (!data.value) {
  throw createError({ statusMessage: 'Failed to fetch block' })
}

const form = reactive({
  title: data.value.item.title,
  subtitle: data.value.item.subtitle,
  synopsis: data.value.item.synopsis,
  featured_image: data.value.item.featured_image,
  primary_cta_label: data.value.item.primary_cta_label,
  primary_cta_link: data.value.item.primary_cta_link,
  secondary_cta_label: data.value.item.secondary_cta_label,
  secondary_cta_link: data.value.item.secondary_cta_link,
  hide_secondary_cta: data.value.item.hide_secondary_cta
})
</script>
